import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { useSkipLink as useSkipLink$1 } from '../../util/useSkipLink.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var skipLinkStyle = {
  hierarchy: 'secondary',
  variant: 'label',
  target: '_self'
};
var useSkipLink = function useSkipLink(_ref) {
  var href = _ref.href,
    label = _ref.label,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size;
  var _useSkipLinkUtil = useSkipLink$1(),
    focusableElementProps = _useSkipLinkUtil.focusableElementProps,
    containerPropsPre = _useSkipLinkUtil.containerProps;
  var containerProps = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, containerPropsPre), {}, {
      p: '8',
      tabIndex: tabIndex
    });
  }, [containerPropsPre, tabIndex]);
  return {
    skipLinkProps: _objectSpread(_objectSpread(_objectSpread({}, focusableElementProps), skipLinkStyle), {}, {
      size: size,
      href: href,
      label: label,
      tabIndex: tabIndex
    }),
    containerProps: containerProps
  };
};

export { useSkipLink };
//# sourceMappingURL=useSkipLink.js.map
